/**
 * CSV Import Feature Hook
 *
 * Handles CSV file selection and upload.
 */

import { useCallback } from 'react';
import { useImportCsv } from '@/entities/account';
import { logger } from '@/shared/lib';
import type { CsvImportState } from './types';

export const useCsvImport = () => {
  const importMutation = useImportCsv();

  const handleImport = useCallback(() => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv';
    input.onchange = async (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;

      try {
        await importMutation.mutateAsync({ body: { file } });
      } catch (error) {
        logger.error('CSV import failed:', error);
      }
    };
    input.click();
  }, [importMutation]);

  const state: CsvImportState = {
    isImporting: importMutation.isPending,
    handleImport,
  };

  return state;
};
